import {
  AttributionCategoryTypeEnum
} from "../services/attributionCategories";
import {
  AdjustmentDetailsAdjustmentType
} from "../models/adjustments";
const isCustomRateAdjustment = (adjustment) => adjustment.description.includes("|CRA|");
const TYPE_TEXT_ADJUSTMENT_TYPES = [
  "Base",
  "Final",
  "AllIn",
  "SRP",
  "Holdback",
  "Profit"
];
const getAdjustmentDetailsType = (adj) => {
  const typeText = adj.typeDescription ?? adj.typeText;
  if (TYPE_TEXT_ADJUSTMENT_TYPES.includes(typeText)) {
    return typeText;
  }
  if (adj.type === AdjustmentDetailsAdjustmentType.Adjustment) {
    return adj.price === null ? "AdjustmentRate" : "AdjustmentPrice";
  }
  if (adj.type === AdjustmentDetailsAdjustmentType.Holdback) {
    return "Holdback";
  }
  return "SRP";
};
const mapAdjustments = ({
  LockRateAdjustments,
  AdjustmentDetailsAdjustments,
  OriginAdjustments,
  ConcessionAdjustments,
  AttributionCategories
}) => {
  let adjustments = [];
  if (AdjustmentDetailsAdjustments && AdjustmentDetailsAdjustments.length > 0) {
    const mappedAdjustmentDetails = AdjustmentDetailsAdjustments.filter(
      (adj) => adj.typeDescription !== "adjustment"
    ).map((adj) => ({
      adjustmentType: getAdjustmentDetailsType(adj),
      // Catch and remove any custom rate adjustments, this model will be discarded
      description: adj.description?.replace(/\|CRA\|-/g, ""),
      price: adj.price,
      rate: adj.rate,
      displayOrder: adj.displayOrder,
      priceVal: adj.priceVal
    }));
    const originDescriptions = new Set(
      (OriginAdjustments ?? []).map(
        (adj) => adj.description?.includes("-") ? adj.description.split("-").pop()?.trim() : adj.description?.trim()
      )
    );
    adjustments = adjustments.concat(
      mappedAdjustmentDetails.filter(
        (adj) => !originDescriptions.has(adj.description?.trim())
      )
    );
  }
  if (LockRateAdjustments && LockRateAdjustments.length > 0) {
    const mappedLockRateAdjustments = LockRateAdjustments.map(
      (adj) => ({
        adjustmentType: adj.adjustmentType,
        description: adj.description,
        price: adj.price,
        rate: adj.rate,
        margin: adj.margin
      })
    );
    adjustments = adjustments.concat(mappedLockRateAdjustments);
  }
  if (OriginAdjustments && OriginAdjustments.length > 0) {
    const mappedOriginAdjustments = OriginAdjustments.filter((adj) => {
      if (LockRateAdjustments?.map((adj2) => adj2.description?.trim()).includes(
        adj.description?.trim()
      )) {
        return false;
      }
      return true;
    }).map((adj) => {
      const mapped = {
        adjustmentType: adj.adjustmentType,
        description: adj.description,
        price: adj.price,
        rate: adj.rate,
        rateLockAdjustmentType: adj.rateLockAdjustmentType,
        priceAdjustmentTypeIndex: adj.priceAdjustmentTypeIndex,
        priceAdjustmentType: adj.priceAdjustmentType,
        paidByGuid: adj.paidByGuid,
        adjustmentReasonGuid: adj.adjustmentReasonGuid,
        displayOrder: 0
      };
      return mapped;
    });
    adjustments = adjustments.concat(mappedOriginAdjustments);
  }
  if (ConcessionAdjustments && ConcessionAdjustments.length > 0) {
    const mappedConcessionAdjustments = ConcessionAdjustments.map((adj) => ({
      adjustmentType: adj.adjustmentType,
      description: adj.description,
      price: adj.price,
      rate: null,
      approvalDate: adj.approvalDate,
      approvedReason: adj.approvedReason,
      approvedBy: adj.approvedBy,
      paidByGuid: adj.paidByGuid,
      adjustmentReasonGuid: adj.adjustmentReasonGuid
    }));
    adjustments = adjustments.concat(mappedConcessionAdjustments);
  }
  if (AttributionCategories && AttributionCategories.length > 0) {
    adjustments = adjustments.map((adj) => {
      if (adj.adjustmentType === "Adjustment" || adj.adjustmentType === "AllIn") {
        return adj;
      }
      const categoryAbbvs = adj.description?.includes("-") ? adj.description.split("-") : [adj.description];
      if (categoryAbbvs.length > 1) {
        const categoryName = categoryAbbvs.pop()?.trim();
        categoryAbbvs.forEach((abbv) => {
          const category = AttributionCategories.find(
            (cat) => cat.abbreviation === abbv.trim()
          );
          if (category && category.attributionCategoryTypeID === AttributionCategoryTypeEnum.AdjustmentReason) {
            adj.adjustmentReasonGuid = category.guid;
          }
          if (category && category.attributionCategoryTypeID === AttributionCategoryTypeEnum.PaidBy) {
            adj.paidByGuid = category.guid;
          }
          adj.description = categoryName || adj.description;
        });
      }
      return adj;
    });
  }
  adjustments.sort((a, b) => {
    if (a.displayOrder !== void 0 && b.displayOrder !== void 0) {
      return a.displayOrder - b.displayOrder;
    }
    return 0;
  });
  return adjustments;
};
export {
  isCustomRateAdjustment,
  mapAdjustments
};
